import React from 'react';
import { motion } from 'framer-motion';

const items = [
  {
    title: "Arrive and Settle In",
    desc: "Begin with a champagne welcome and take in the estate at your own pace.",
    color: "bg-floral-marigold"
  },
  {
    title: "Explore the Estate",
    desc: "Walk through the ceremony spaces, gardens, courtyards, and reception areas.",
    color: "bg-floral-apricot"
  },
  {
    title: "Taste the Experience",
    desc: "Enjoy curated bites, desserts, coffee tastings, mocktails, and hosted refreshments.",
    color: "bg-floral-coral"
  },
  {
    title: "Meet Trusted Wedding Professionals",
    desc: "Connect with photographers, florists, entertainers, designers, and culinary partners selected to complement the Padua experience.",
    color: "bg-floral-plum"
  },
  {
    title: "Gather Ideas for Your Wedding",
    desc: "Discover thoughtful details, visual inspiration, and possibilities for your celebration.",
    color: "bg-floral-olive"
  },
  {
    title: "Explore Booking Enhancements",
    desc: "Couples who attend and move forward using an event estimate may receive a special wedding enhancement approved by the Padua team.",
    color: "bg-estate-gold"
  }
];

export default function Expectations() {
  return (
    <section className="bg-ivory px-6 py-16 md:py-32 relative">
      <div className="max-w-6xl mx-auto">
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-12 md:mb-20"
        >
          <span className="font-sans text-[10px] md:text-xs uppercase tracking-[0.4em] text-floral-marigold block mb-3 md:mb-4">
            The Experience
          </span>
          <h2 className="font-serif text-3xl md:text-6xl text-burgundy">
            Your Afternoon at Padua
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-10">
          {items.map((item, index) => (
            <motion.div 
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="bg-aged-ivory border-[0.5px] border-estate-gold/20 p-8 md:p-10 hover:border-burgundy/30 transition-all duration-500 text-center group relative overflow-hidden"
            >
              <div className={`absolute top-0 left-0 w-full h-1 ${item.color} opacity-20 group-hover:opacity-100 transition-opacity duration-500`}></div>
              <span className={`inline-block w-1.5 h-1.5 md:w-2 md:h-2 rounded-full ${item.color} mb-5 md:mb-6 group-hover:scale-150 transition-transform duration-500`}></span>
              <h3 className="font-serif text-lg md:text-2xl text-burgundy mb-3 md:mb-4 group-hover:text-floral-plum transition-colors px-2">
                {item.title}
              </h3>
              <p className="font-sans font-light text-[13px] md:text-sm text-charcoal/60 leading-relaxed">
                {item.desc}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}